
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

//import CancelIcon from '@material-ui/icons/Cancel';

import CircularProgress from '@material-ui/core/CircularProgress';

const CustomTableCell = withStyles(theme => ({
  head: {
    fontFamily: 'Flanders Art Sans!important',
    textAlign: 'center',
    //fontWeight: 700,
    padding: '16px!important',
    paddingTop: '2px!important',
    paddingBottom: '2px!important',
    fontSize: '14pt',
    /*[theme.breakpoints.down('xs')]: {
      fontSize: '1.1em',
    },*/
  },
  body: {
    color: '#105269',
    fontFamily: 'Flanders Art Sans!important',
    borderBottom: '0px!important',
    paddingTop: '4px!important',
    paddingBottom: '4px!important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10pt',
      //paddingTop: '4px!important',
      //paddingBottom: '4px!important',
      paddingLeft: '5px',
      paddingRight: '2px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '12pt',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '14pt',
    },
  },
}))(TableCell);

const styles = theme => ({
  table: {
    width: '100%',
    marginTop: '10px',
    overflowX: 'auto',
    borderSpacing: '0px',
    borderCollapse: 'collapse',
    fontFamily: 'Flanders Art Sans!important',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '300px!important',
    },
  },
  row: {
    height: '25px',

    //'&:nth-of-type(odd)': {
    //  backgroundColor: theme.palette.background.default,
    //},
  },
  labelCell: {
    //color: '#e2183a!important',
    [theme.breakpoints.down('sm')]: {
      width: '25%',
      fontSize: '0.9em',
    },
    [theme.breakpoints.up('sm')]: {
      width: '45%',
    },
    [theme.breakpoints.up('md')]: {
      width: '45%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '40%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '40%',
    },

  },
  productionValueCell: {
    //fontWeight: 700,
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      width: '30%',
      fontSize: '0.9em',
    },
    [theme.breakpoints.up('sm')]: {
      width: '30%',
    },
    [theme.breakpoints.up('md')]: {
      width: '20%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '30%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '25%',
    },

  },
  familyValueCell: {
    //fontWeight: 700,
    textAlign: 'right',
    //borderLeft: '1px solid rgba(107,108,110,0.5)',
    [theme.breakpoints.down('sm')]: {
      width: '25%',
      fontSize: '0.9em',
    },
    [theme.breakpoints.up('sm')]: {
      width: '25%',
    },
    [theme.breakpoints.up('md')]: {
      width: '35%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '30%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '35%',
    },

  },
  totalCell: {
    //fontWeight: 600,
    fontSize: '14pt',
    borderLeft: '0px!important',
    borderRight: '0px!important',
    borderBottom: '0px!important',
    [theme.breakpoints.down('sm')]: {
      //fontWeight: 500,
      fontSize: '12pt',
    },
  },
});

function ProvinceBox(props) {
  //const [showTable, setShowTable] = useState(false)
  //
  //function toggleTable() {
  //  setShowTable(prevShowTable => !prevShowTable)
  //}

  const { classes } = props
  let overviewData = props.provinceData
  let overviewDataWithoutOffshore = props.provinceDataWithoutOffshore

  if (overviewData === undefined || overviewDataWithoutOffshore === undefined)
    return <CircularProgress className={classes.progress} size={50} />

  const totalProductionData = overviewData['energy_sum']
  const totalProductionDataWithoutOffshore = overviewDataWithoutOffshore['energy_sum']
  const totalFamilyData = overviewData['nb_household_covered']

  const provinceData = overviewData['energy_per_province']
  const familyData = overviewData['family_per_province']

  let production
  let numberFamilies
  let totalWallonie
  let windOffshore
  let northSea
  switch (props.lang) {
    case 'de':
      production = "Produktion"
      numberFamilies = "Familien"
      totalWallonie = "Total (Wallonie)"
      windOffshore = "Wind offshore"
      northSea = "Nordmeer"
      break;
    case 'en':
      production = "Production"
      numberFamilies = "Number families"
      totalWallonie = "Total (Wallonie)"
      windOffshore = "Wind offshore"
      northSea = "North sea"
      break;
    case 'fr':
      production = "Production"
      numberFamilies = "Nombre foyers"
      totalWallonie = "Totale (Wallonie)"
      windOffshore = "Éolienne offshore"
      northSea = "Mer du nord"
      break;
    case "nl":
    default:
      production = "Productie"
      numberFamilies = "Gezinnen voorzien"
      totalWallonie = "Totaal (Vlaanderen)"
      windOffshore = "Offshore wind"
      northSea = "Noordzee"
  }

  let energyTypeWithoutOffshore
  switch (props.lang) {
    case "de":
      energyTypeWithoutOffshore = (
        props.currentTech.solar ? (
          props.currentTech.wind ? "Sonne und Wind onshore" : "Sonne"
        )
          : props.currentTech.wind ? "Wind onshore" : ""
      )
      break
    case "en":
      energyTypeWithoutOffshore = (
        props.currentTech.solar ? (
          props.currentTech.wind ? "solar and wind onshore" : "solar"
        )
          : props.currentTech.wind ? "Wind onshore" : ""
      )
      break
    case "fr":
      energyTypeWithoutOffshore = (
        props.currentTech.solar ? (
          props.currentTech.wind ? "solaire et éolienne onshore" : "solaire"
        )
          : props.currentTech.wind ? "éolienne onshore" : ""
      )
      break
    case "nl":
    default:
      energyTypeWithoutOffshore = (
        props.currentTech.solar ? (
          props.currentTech.wind ? "solaire et éolienne onshore" : "solaire"
        )
          : props.currentTech.wind ? "éolienne onshore" : ""
      )
  }

  let periodIdentification
  switch (props.currentMode) {
    case 'realtime':
      periodIdentification = props.daySelected.substring(6, 8) + "." + props.daySelected.substring(4, 6) + "." + props.daySelected.substring(0, 4)
      break;
    case 'historical':
    default:
      periodIdentification = props.yearSelected
  }

  //let vlaanderenProductionValue=0
  let vlaanderenFamilyValue=0
  Object
    .keys(provinceData)
    .filter(provinceName => provinceName !== 'Noordzee (B)')
    .map((provinceName) => {
      //vlaanderenProductionValue= parseInt(provinceData[provinceName].value)
      vlaanderenFamilyValue += parseInt(familyData[provinceName].value);
      return true;
    })

  let offshoreFamilyValue = 0
  if (props.currentTech.windOffshore) {
    Object
      .keys(provinceData)
      .filter(provinceName => provinceName === 'Noordzee (B)')
      .map((provinceName) => {
        offshoreFamilyValue = parseInt(familyData[provinceName].value);
        return true;
      })
  }

  return (
    <Fragment>
      {
        Object.keys(props.provinceData).length > 0 &&
        <Table
          className={classes.table}
        >
          <TableHead>
            <TableRow>
              <CustomTableCell className="darkbluegreen"> {/*energyTypeWithoutOffshore periodIdentification*/}</CustomTableCell>
              <CustomTableCell className="darkbluegreen" style={{textAlign:'right'}}>{production}</CustomTableCell>
              <CustomTableCell className="darkbluegreen" style={{textAlign:'right'}}>{numberFamilies}</CustomTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              Object
                .keys(provinceData)
                .filter(provinceName => provinceName !== 'Noordzee (B)')
                .map((provinceName) => (
                  <TableRow className={classes.row} key={provinceName}>
                    <CustomTableCell className={classes.labelCell + " darkbluegreen"}>{provinceName}</CustomTableCell>
                    <CustomTableCell className={classes.productionValueCell}>{parseInt(provinceData[provinceName].value).toLocaleString('nl-BE')} {provinceData[provinceName].unit}</CustomTableCell>
                    <CustomTableCell className={classes.familyValueCell}>{(parseInt(familyData[provinceName].value)).toLocaleString('nl-BE')}</CustomTableCell>
                  </TableRow>
                ))
            }
            <TableRow className={classes.totalRow} style={{ textAlign: 'right'}}>
              <CustomTableCell className={classes.labelCell + " darkbluegreen " + classes.totalCell}>{props.currentTech.solar || props.currentTech.wind?(props.currentTech.windOffshore?"Vlaanderen":"Totaal"):""}</CustomTableCell>
              <CustomTableCell className={classes.productionValueCell + " " + classes.totalCell}>{parseInt(totalProductionDataWithoutOffshore.value).toLocaleString('nl-BE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} {totalProductionDataWithoutOffshore.unit}</CustomTableCell>
              <CustomTableCell className={classes.familyValueCell + " " + classes.totalCell}>{vlaanderenFamilyValue.toLocaleString('nl-BE')}</CustomTableCell>
            </TableRow>
          </TableBody>
        </Table>
      }
      {props.currentTech.windOffshore && (
        <Table
          className={classes.table}
        > 
          <TableBody>
        {
              Object
                .keys(provinceData)
                .filter(provinceName => provinceName === 'Noordzee (B)')
                .map((provinceName) => (
                  <TableRow className={classes.row} key={provinceName}>
                    <CustomTableCell className={classes.labelCell}>{provinceName}</CustomTableCell>
                    <CustomTableCell className={classes.productionValueCell}>{parseInt(provinceData[provinceName].value).toLocaleString('nl-BE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} {provinceData[provinceName].unit}</CustomTableCell>
                    <CustomTableCell className={classes.familyValueCell}>{offshoreFamilyValue.toLocaleString('nl-BE')}</CustomTableCell>
                  </TableRow>
                ))
            }
            </TableBody>
        </Table>
      )}
      {(props.currentTech.windOffshore && (props.currentTech.solar || props.currentTech.wind)) && (
        <Table
          className={classes.table}
        >
          <TableBody>
            <TableRow className={classes.totalRow} style={{ textAlign: 'right'}}>
              <CustomTableCell className={classes.labelCell + " " + classes.totalCell}>Vlaanderen en Noordzee</CustomTableCell>
            {
            /*
              <CustomTableCell className={classes.productionValueCell + " " + classes.totalCell}>{parseFloat(totalProductionData.value).toLocaleString('nl-BE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} {totalProductionData.unit}</CustomTableCell>
            */
            }  
              <CustomTableCell className={classes.productionValueCell + " " + classes.totalCell}>{parseInt(totalProductionData.value).toLocaleString('nl-BE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} {totalProductionData.unit}</CustomTableCell>
              <CustomTableCell className={classes.familyValueCell + " " + classes.totalCell}>{(vlaanderenFamilyValue + offshoreFamilyValue).toLocaleString('nl-BE')}</CustomTableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
    </Fragment>
  );
}
ProvinceBox.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProvinceBox);
